module.exports = __webpack_public_path__ + "static/img/HU.78a0eafb.jpg";